import { Stack } from '@mui/material';
import React from 'react';

import { ReportJobNestedSectionCombineMode, ReportJobNestedSectionLayoutMode } from 'utils/reportJobSections';
import ReportJobSectionCombineModeToggle from './ReportJobSectionCombineModeToggle';
import ReportJobSectionDisplayModeToggle from './ReportJobSectionDisplayModeToggle';

interface Props {
  combineMode: ReportJobNestedSectionCombineMode;
  layoutMode: ReportJobNestedSectionLayoutMode;
  onCombineModeChange: (value: ReportJobNestedSectionCombineMode) => void;
  onLayoutModeChange: (value: ReportJobNestedSectionLayoutMode) => void;
}

const ReportJobSectionNestedControls: React.FC<Props> = ({
  combineMode,
  layoutMode,
  onCombineModeChange,
  onLayoutModeChange,
}) => (
  <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} sx={{ minWidth: 0 }}>
    <Stack spacing={0.5} sx={{ minWidth: 0 }}>
      <ReportJobSectionCombineModeToggle value={combineMode} onChange={onCombineModeChange} />
    </Stack>
    {combineMode === 'unwound' ? (
      <Stack spacing={0.5} sx={{ minWidth: 0 }}>
        <ReportJobSectionDisplayModeToggle value={layoutMode} onChange={onLayoutModeChange} />
      </Stack>
    ) : null}
  </Stack>
);

export default ReportJobSectionNestedControls;
